import React from "react";
import { Button } from "react-bootstrap";
import ReactSelect from "react-select";
import AddBusiness from "./partials/AddBusiness";

import Businesslist from "./partials/Businesslist";

export default function Business() {
  // Sample options for currency and countries
  
  return (
    <>
      <div className="container d-flex justify-content-between align-items-center my-5">
        <div className="row">
          <div className="col-12">
            <div className="pageTitle">
              <h1>Business</h1>
            </div>
          </div>
        </div>
        <div className="">
          <div className="col-12">
            <AddBusiness />
          </div>
        </div>
      </div>
      <Businesslist />
    </>
  );
}
